module.exports = __webpack_public_path__ + "img/dabiao_80W.19fc1865.png";